module.exports = __webpack_public_path__ + "static/media/undraw_Hello_qnas.0992b998.svg";